export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f5250ebb5f98594cdf608911b9e611e58844e0751&name=sendEvent!'